import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from './contexts/AuthContext.js';
import { AppLayout } from './layouts/AppLayout.js';

import { Login } from './pages/Login.js';
import { Dashboard } from './pages/Dashboard.js';
import { Customers } from './pages/Customers.js';
import { Plans } from './pages/Plans.js';
import { Subscriptions } from './pages/Subscriptions.js';
import { Payments } from './pages/Payments.js';
import { Usage } from './pages/Usage.js';
import { Processings } from './pages/Processings.js';
import { Servers } from './pages/Servers.js';
import { Voices } from './pages/Voices.js';
import { Reports } from './pages/Reports.js';
import { Admins } from './pages/Admins.js';
import { Settings } from './pages/Settings.js';
import { DriveTransfers } from './pages/DriveTransfers.js';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      staleTime: 30000,
    },
  },
});

export const App: React.FC = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />

            <Route element={<AppLayout />}>
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/clientes" element={<Customers />} />
              <Route path="/planos" element={<Plans />} />
              <Route path="/assinaturas" element={<Subscriptions />} />
              <Route path="/pagamentos" element={<Payments />} />
              <Route path="/utilizacao" element={<Usage />} />
              <Route path="/processamentos" element={<Processings />} />
              <Route path="/transferencias" element={<DriveTransfers />} />
              <Route path="/transferencias-drive" element={<Navigate to="/transferencias" replace />} />
              <Route path="/servidores" element={<Servers />} />
              <Route path="/vozes" element={<Voices />} />
              <Route path="/relatorios" element={<Reports />} />
              <Route path="/administradores" element={<Admins />} />
              <Route path="/configuracoes" element={<Settings />} />
            </Route>

            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </QueryClientProvider>
  );
};

export default App;
